module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "c01"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ct sgc-1"
  }, [_vm._v("\n    being here\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("\n    Listless blight, safe words, every little"), _c('br'), _vm._v("\n    Sound in the night is a gasp—bone tip\n  ")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("\n    Blossoming through skin. It’s no"), _c('br'), _vm._v("\n    Bull, man. Anymore, we’re all winners\n  ")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("\n    & afraid to pull these faces off."), _c('br'), _vm._v("\n    Maple leaves & plastic bags somersault\n  ")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("\n    Through the park. One cloud"), _c('br'), _vm._v("\n    Grips the moon. Call me anything\n  ")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("\n    Before morning comes, little lover,"), _c('br'), _vm._v("\n    Because it’s true & doesn’t fucking matter.\n  ")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("\n    Kill the lights. Feel the burn. Rev yourself"), _c('br'), _vm._v("\n    Up & sing along with the good thrum\n  ")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_vm._v("\n    Found in everything. Hang around"), _c('br'), _vm._v("\n    Until the end. Melt my ashes on your tongue.\n  ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c844135","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/alex_9781571318060_oeb_c01_r1.vue
// module id = 75
// module chunks = 0